import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const BusinessViewContent = lazy(() => import('../../../components/Pages/Businesses/[businessId]'));

export default function BusinessView(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Business View page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <BusinessViewContent />
      </Suspense>
    </Layout>
  );
}
